//Assumes one "url parameter"- replaces all slashes and # symbols
const safeEscape = (name: string) => {
   //Manually replace slashes and number signs because encode will assume it's part of the url
   return encodeURI(name.replaceAll('/', '%2f').replaceAll('#', '%23'));
};

export const docLink = (doc_title: string, docid: number, doctype: string) => {
   if (!doc_title) return '';
   if (doctype === 'GUIDE') {
      return guideLink(doc_title, docid);
   } else {
      return wikiLink(doc_title, false);
   }
};

export const guideLink = (
   guide_title: string,
   guideid: number,
   release: number | string | null = null
) => {
   if (!guide_title) return '';
   if (release) {
      return `/Guide/${safeEscape(guide_title)}/${guideid}?release=${release}`;
   }
   return `/Guide/${safeEscape(guide_title)}/${guideid}`;
};

export const guideLinkQuizEditPanel = (guideid: number) => {
   return `/Guide/intro/quiz/${guideid}`;
};

export const categoryLink = (category_title: string) => {
   if (!category_title) return '';
   return `/c/${safeEscape(category_title)}`;
};

export const wikiLink = (wiki_title: string, editPage: boolean = false) => {
   if (!wiki_title) return '';
   if (editPage) {
      return `/Wiki/Edit/${safeEscape(wiki_title)}`;
   }
   return `/Wiki/${safeEscape(wiki_title)}`;
};

export const wikiLinkQuizEditPanel = (wiki_title: string) => {
   if (!wiki_title) return '';
   return wikiLink(wiki_title, true) + '/quiz';
};
